import { render, staticRenderFns } from "./CustomerCardComponent.vue?vue&type=template&id=0a67d520&scoped=true&"
import script from "./CustomerCardComponent.vue?vue&type=script&lang=js&"
export * from "./CustomerCardComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a67d520",
  null
  
)

export default component.exports